/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * eCFR SDK
 * TypeScript SDK and Model Context Protocol server for the Electronic Code of Federal Regulations (eCFR) API
 * OpenAPI spec version: 1.0.0
 */
import type {
  GetApiAdminV1CorrectionsJsonParams,
  GetApiSearchV1CountParams,
  GetApiSearchV1CountsDailyParams,
  GetApiSearchV1CountsHierarchyParams,
  GetApiSearchV1CountsTitlesParams,
  GetApiSearchV1Results200,
  GetApiSearchV1ResultsParams,
  GetApiSearchV1SuggestionsParams,
  GetApiSearchV1SummaryParams,
  GetApiVersionerV1AncestryDateTitleTitleJsonParams,
  GetApiVersionerV1FullDateTitleTitleXmlParams,
  GetApiVersionerV1VersionsTitleTitleJsonParams
} from './model';

import { customInstance } from '../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * All top-level agencies in name order with children also in name order
 * @summary Agencies
 */
export const getApiAdminV1AgenciesJson = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `https://www.ecfr.gov/api/admin/v1/agencies.json`, method: 'GET'
    },
      options);
    }
  
/**
 * The Corrections service can be used to determine all corrections or can be filtered by title, effective date, or correction date.

 * @summary Corrections route returns all eCFR corrections.
 */
export const getApiAdminV1CorrectionsJson = (
    params?: GetApiAdminV1CorrectionsJsonParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `https://www.ecfr.gov/api/admin/v1/corrections.json`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * The Corrections service can be used to determine all corrections for the given title.
 * @summary Corrections title route returns all corrections for the supplied title.
 */
export const getApiAdminV1CorrectionsTitleTitleJson = (
    title: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `https://www.ecfr.gov/api/admin/v1/corrections/title/${title}.json`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Search results
 */
export const getApiSearchV1Results = (
    params?: GetApiSearchV1ResultsParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<GetApiSearchV1Results200>(
      {url: `https://www.ecfr.gov/api/search/v1/results`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Search result count
 */
export const getApiSearchV1Count = (
    params?: GetApiSearchV1CountParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `https://www.ecfr.gov/api/search/v1/count`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Search summary details
 */
export const getApiSearchV1Summary = (
    params?: GetApiSearchV1SummaryParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `https://www.ecfr.gov/api/search/v1/summary`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Search result counts by date
 */
export const getApiSearchV1CountsDaily = (
    params?: GetApiSearchV1CountsDailyParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `https://www.ecfr.gov/api/search/v1/counts/daily`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Search result counts by title
 */
export const getApiSearchV1CountsTitles = (
    params?: GetApiSearchV1CountsTitlesParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `https://www.ecfr.gov/api/search/v1/counts/titles`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Search result counts by hierarchy
 */
export const getApiSearchV1CountsHierarchy = (
    params?: GetApiSearchV1CountsHierarchyParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `https://www.ecfr.gov/api/search/v1/counts/hierarchy`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Search suggestions
 */
export const getApiSearchV1Suggestions = (
    params?: GetApiSearchV1SuggestionsParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `https://www.ecfr.gov/api/search/v1/suggestions`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * The Ancestry service can be used to determine the complete ancestry to a leaf node at a specific point in time.
### Example
The complete hierarchy for **2 CFR 1532.137** is
```
Title 2
  Subtitle B
    Chapter XV
      Part 1532
        Subpart A
          Section 1532.137
```
To retrieve this complete hierarchy you can use the ancestry endpoint and provide a Title, Part and Section (you can provide additional layers of the hierarchy) to retrieve a full ancestry.
See sample json responses below.

 * @summary Ancestors route returns all ancestors (including self) from a given level through the top title node.
 */
export const getApiVersionerV1AncestryDateTitleTitleJson = (
    date: string | undefined | null,
    title: string | undefined | null,
    params?: GetApiVersionerV1AncestryDateTitleTitleJsonParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `https://www.ecfr.gov/api/versioner/v1/ancestry/${date}/title-${title}.json`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * The title source route can be used to retrieve the source xml for a complete title or subset. The subset of xml is determined by the lowest leaf node given. For example, if you request Title 1, Chapter I, Part 1, you'll receive the XML only for Part 1 and its children.
If you request a section you'll receive the section XML inside its parent Part as well as relevant non-section sibling nodes (Auth, Source, etc).
The largest title source xml files can be dozens of megabytes.

[GPO eCFR XML User guide](https://github.com/usgpo/bulk-data/blob/master/ECFR-XML-User-Guide.md)

 * @summary Source XML for a title or subset of a title. Requests can be for entire titles or part level and below.  Downloadable XML document is returned for title requests.  Processed XML is returned if part, subpart, section, or appendix is requested.
 */
export const getApiVersionerV1FullDateTitleTitleXml = (
    date: string | undefined | null,
    title: string | undefined | null,
    params?: GetApiVersionerV1FullDateTitleTitleXmlParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<string>(
      {url: `https://www.ecfr.gov/api/versioner/v1/full/${date}/title-${title}.xml`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * The structure JSON endpoint returns the complete structure of a title back as json. This format does not include the content of the title but does include all structure and content nodes as well as their meta data including their type, label, description, identifier and children.
 * @summary Structure JSON for a title
 */
export const getApiVersionerV1StructureDateTitleTitleJson = (
    date: string | undefined | null,
    title: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `https://www.ecfr.gov/api/versioner/v1/structure/${date}/title-${title}.json`, method: 'GET'
    },
      options);
    }
  
/**
 * The Title service can be used to determine the status of each individual title and of the overall status of title imports and reprocessings. It returns an array of all titles containing a hash for each with the name of the title, the latest amended date, latest issue date, up-to-date date, reserved status, and if applicable, processing in progress status. The meta data returned indicates the latest issue date and whether titles are currently being reprocessed.
 * @summary Summary information about each title
 */
export const getApiVersionerV1TitlesJson = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `https://www.ecfr.gov/api/versioner/v1/titles.json`, method: 'GET'
    },
      options);
    }
  
/**
 * Returns the content versions meeting the specified criteria. Each content object includes its identifier, parent hierarchy, last amendment date and issue date it was last updated. Queries return content versions `on` an issue date, or before or on a specific issue date `lte` or on or after `gte` a specific issue date. The `gte` and `lte` parameters may be combined. Use of the `on` parameter precludes use of `gte` or `lte`. In the response, the `date` field is identical to `amendment_date` and is deprecated.
<br>
A response of `400 Bad Request` indicates that your request could not be processed. If possible the response will include a message indicating the problem.
<br>
A response of `503 Service Unavailable` indicates that the title is currently unavailable, typlically because it is currently being processed. The value of the `Retry-After` header suggests a number of seconds to wait before retrying the request.

 * @summary Returns an array of all sections and appendices inside a title.
 */
export const getApiVersionerV1VersionsTitleTitleJson = (
    title: string | undefined | null,
    params?: GetApiVersionerV1VersionsTitleTitleJsonParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `https://www.ecfr.gov/api/versioner/v1/versions/title-${title}.json`, method: 'GET',
        params
    },
      options);
    }
  
export type GetApiAdminV1AgenciesJsonResult = NonNullable<Awaited<ReturnType<typeof getApiAdminV1AgenciesJson>>>
export type GetApiAdminV1CorrectionsJsonResult = NonNullable<Awaited<ReturnType<typeof getApiAdminV1CorrectionsJson>>>
export type GetApiAdminV1CorrectionsTitleTitleJsonResult = NonNullable<Awaited<ReturnType<typeof getApiAdminV1CorrectionsTitleTitleJson>>>
export type GetApiSearchV1ResultsResult = NonNullable<Awaited<ReturnType<typeof getApiSearchV1Results>>>
export type GetApiSearchV1CountResult = NonNullable<Awaited<ReturnType<typeof getApiSearchV1Count>>>
export type GetApiSearchV1SummaryResult = NonNullable<Awaited<ReturnType<typeof getApiSearchV1Summary>>>
export type GetApiSearchV1CountsDailyResult = NonNullable<Awaited<ReturnType<typeof getApiSearchV1CountsDaily>>>
export type GetApiSearchV1CountsTitlesResult = NonNullable<Awaited<ReturnType<typeof getApiSearchV1CountsTitles>>>
export type GetApiSearchV1CountsHierarchyResult = NonNullable<Awaited<ReturnType<typeof getApiSearchV1CountsHierarchy>>>
export type GetApiSearchV1SuggestionsResult = NonNullable<Awaited<ReturnType<typeof getApiSearchV1Suggestions>>>
export type GetApiVersionerV1AncestryDateTitleTitleJsonResult = NonNullable<Awaited<ReturnType<typeof getApiVersionerV1AncestryDateTitleTitleJson>>>
export type GetApiVersionerV1FullDateTitleTitleXmlResult = NonNullable<Awaited<ReturnType<typeof getApiVersionerV1FullDateTitleTitleXml>>>
export type GetApiVersionerV1StructureDateTitleTitleJsonResult = NonNullable<Awaited<ReturnType<typeof getApiVersionerV1StructureDateTitleTitleJson>>>
export type GetApiVersionerV1TitlesJsonResult = NonNullable<Awaited<ReturnType<typeof getApiVersionerV1TitlesJson>>>
export type GetApiVersionerV1VersionsTitleTitleJsonResult = NonNullable<Awaited<ReturnType<typeof getApiVersionerV1VersionsTitleTitleJson>>>
